import { ErrorOutline, OpenInNew } from "@mui/icons-material";
import { useEffect, useState } from "react";
import Button from "~/components/ui/button";
import Modal from "~/components/ui/modal";
import styles from "./index.module.scss";

interface NewApiWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (dontShowAgain: boolean) => void;
}

const NewApiWarningModal: React.FC<NewApiWarningModalProps> = ({ isOpen, onClose, onConfirm }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setDontShowAgain(false);
    }
  }, [isOpen]);

  return (
    <Modal
      label="kintone APIラボの有効化について"
      isOpen={isOpen}
      onClose={onClose}
      className={styles["newApiWarningModal"] ?? ""}
      content={
        <div className={styles["modalContent"]}>
          <div className={styles["heroSection"]}>
            <div className={styles["iconWrapper"]}>
              <ErrorOutline className={styles["warningIcon"] ?? ""} />
            </div>
            <h2 className={styles["heroTitle"]}>kintone APIラボの有効化が必要です</h2>
            <p className={styles["heroSubtitle"]}>
              アプリ生成機能はkintone APIラボのスペースAPIを使用しています
            </p>
          </div>

          <div className={styles["contentSection"]}>
            <div className={styles["infoCard"]}>
              <p className={styles["infoText"]}>
                この機能を利用するには、kintone管理者が事前に
                <strong>APIラボのスペースAPIを有効化</strong>
                する必要があります。
                有効化されていない場合、アプリ生成が正常に動作しない可能性があります。
              </p>
            </div>

            <div className={styles["linksSection"]}>
              <p className={styles["linksLabel"]}>設定方法・詳細情報</p>
              <div className={styles["linkCards"]}>
                <a
                  href="https://jp.kintone.help/k/ja/id/04051#new_feature_target_features_409542"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["linkCard"]}
                >
                  <span className={styles["linkTitle"]}>対象となる新機能一覧</span>
                  <span className={styles["linkDescription"]}>有効化が必要な機能を確認</span>
                  <OpenInNew className={styles["linkIcon"] ?? ""} />
                </a>
                <a
                  href="https://jp.kintone.help/k/ja/admin/new_feature/new_feature_overview#new_feature_new_feature_overview_2040"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["linkCard"]}
                >
                  <span className={styles["linkTitle"]}>有効化の設定方法</span>
                  <span className={styles["linkDescription"]}>管理画面での設定手順</span>
                  <OpenInNew className={styles["linkIcon"] ?? ""} />
                </a>
              </div>
            </div>
          </div>

          <div className={styles["checkboxContainer"]}>
            <label className={styles["checkboxLabel"]}>
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
                className={styles["checkbox"]}
              />
              今後表示しない
            </label>
          </div>

          <div className={styles["buttonContainer"]}>
            <Button styleType="white-middle" label="キャンセル" onClick={onClose} />
            <Button
              styleType="blue-middle"
              label="確認して続行"
              onClick={() => onConfirm(dontShowAgain)}
            />
          </div>
        </div>
      }
    />
  );
};

export default NewApiWarningModal;
